import { cloneDeep } from 'lodash';

const state = {
  list: []
};

const getters = {
  list(state) {
    return state.list || [];
  }
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_PROMO_CODE(state, item) {
    const index = state.list.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      this._vm.$set(state.list, index, cloneDeep(item));
    } else {
      state.list.unshift(cloneDeep(item));
    }
  },
  REMOVE_PROMO_CODE(state, id) {
    state.list = state.list.filter((x) => x.id !== id);
  }
};

const actions = {
  async getList({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get('promocodes/getList')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async save({ commit }, item) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post('promocodes/save', item)
        .then((response) => {
          commit('SET_PROMO_CODE', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post(`promocodes/delete?id=${id}`)
        .then(() => {
          commit('REMOVE_PROMO_CODE', id);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
